import { render } from "./CreditPage.vue?vue&type=template&id=315383ae&scoped=true"
import script from "./CreditPage.vue?vue&type=script&lang=js"
export * from "./CreditPage.vue?vue&type=script&lang=js"

import "./CreditPage.vue?vue&type=style&index=0&id=315383ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-315383ae"]])

export default __exports__